<template>
  <div id="vaccineFAQ" class="w-full relative pt-24 pb-24">
    <title-w-star :title="t('covid19.faqsTitle')" titleColor="#1687A7" :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }" />

    <collapse-group :descriptionList="covid19Store.faqsList" labelColor="#1687A7" />

    <!-- <div class="absolute left-0 -z-10" style="width: 9.5vw; bottom: 6%">
      <img :src="commonStore.getImgUrl('shared', 'starGroupIconSeaBlueLeft', 'svg')" />
    </div> -->

    <!-- <div id="usefulArticles" style="width: 60vw">
        <div class="font-bold text-sea-blue">{{ t("covid19.usefulArticlesTitle") }}:</div>
        <div id="usefulArticlesList" class="flex flex-col mt-5 space-y-5">
          <div v-for="item in covid19Store.usefulArticlesList" :key="'usefulArticlesLabel' + item.id" class="flex">
            <div v-html="t(item.label)" style="width: 30%" class="text-2xl font-bold" />

            <ul>
              <li v-for="(elem, index) in item.itemList" :key="'usefulArticlesDesc' + index" class="text-links">
                <a :href="elem.url" target="_blank" class="underline decoration-1 text-links">{{ t(elem.label) }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { useCovid19Store } from "@/stores/covid19";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";

const commonStore = useCommonStore();
const covid19Store = useCovid19Store();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  if (covid19Store.selectedGovVenue && Object.keys(covid19Store.selectedGovVenue).length === 0 && Object.getPrototypeOf(covid19Store.selectedGovVenue) === Object.prototype) {
    covid19Store.selectedGovVenue = covid19Store.governmentVenueList[0];
  }
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>

<style>
u {
  text-decoration-line: underline;
  cursor: pointer;
  color: #1b77e2;
}
</style>